import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { PageHeader } from "../../components/PageHeader";
import { NavTab } from "../../components/Tabs/NavTabs.container";
import { RoutePath } from "../../defines/route-path";
import { useAuthContext } from "../../contexts/authentication/AuthenticationContext";
import { Role } from "../../core/models/User";

const ProofsRequests = () => {
  const { userInfo } = useAuthContext();

  const tabs: Array<NavTab> =
    userInfo?.permissionRole === Role.Business
      ? [{ label: "requests", href: RoutePath.REQUESTS }]
      : [
          { label: "proofs", href: RoutePath.PROOFS },
          { label: "requests", href: RoutePath.REQUESTS },
        ];

  return (
    <Box
      id="pageWrapper"
      className="w-full flex flex-col flex-1 space-y-[1.875rem]"
    >
      <PageHeader titleTranslationKey="sharing" tabs={tabs} />
      <Box className="h-full">
        <Outlet />
      </Box>
    </Box>
  );
};

export { ProofsRequests };
